import { NotificationTargetAudience } from '@sportspredict/shared';

export const TARGET_AUDIENCE_LABELS = {
	[NotificationTargetAudience.AllUsers]: 'All Users',
	[NotificationTargetAudience.UsersWithTrades]: 'With Trades',
	[NotificationTargetAudience.UsersWithZeroTrades]: 'Zero Trades',
};

export const PROBABILITY_EVENT_TARGET_AUDIENCE_LABELS = {
	[NotificationTargetAudience.ZeroLlmBots]: 'Zero LLM-Bots',
};

export const initialNotification = {
	title: '',
	message: '',
	type: 'event',
	is_global: true,
	target_users: [],
	link: '',
	expire_date: null,
	target_audience: NotificationTargetAudience.AllUsers,
	is_event_wide: true,
	lobby_ids: [],
};
